(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordions-faqs"] && !Shopify.designMode) return;
  try {
    
    (function() {
        'use strict';
        
        // Click handler for the accordion buttons
        function handleAccordionAccessibility() {
            const button = this;
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const panel = document.getElementById(button.getAttribute('aria-controls'));
            
            !panel && console.warn('Accordion panel not found for button:', button);
            
            if (!isExpanded) {
                // Set as expanded and enable accessibility
                button.setAttribute('aria-expanded', 'true');
                panel && panel.removeAttribute('inert');
            } else {
                // Set as collapsed and disable accessibility
                button.setAttribute('aria-expanded', 'false');
                panel && panel.setAttribute('inert', '');
            }
            
            // Alpine.js handles the visual animation via x-bind:style
            // We only handle accessibility state here
        }
        
        // Initializer of accordion markup and event binding
        function initAccordions() {
            const accordionButtons = [...document.querySelectorAll('.accordion-button')];
            
            // Iterate over accordion instances (if found)
            accordionButtons.forEach(function(button) {
                const panel = document.getElementById(button.getAttribute('aria-controls'));
                const links = panel ? [...panel.querySelectorAll('a[href]:not([disabled])')] : [];
                
                // If links found in panel, set the accessibility attribute
                links.forEach(function(link) {
                    link.setAttribute('tabindex', '0');
                });
                
                // Bind the button to the click handler
                button.addEventListener('click', handleAccordionAccessibility);
            });
        }
        
        // Bind setup and init
        document.addEventListener('DOMContentLoaded', function(e) {
            // Setup & initialize accordions
            initAccordions();
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listing-events"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event){
    document.querySelectorAll("[data-event-end-date]").forEach(function(element){
      var endDate = new Date(element.dataset.eventEndDate);
      if(endDate instanceof Date && !isNaN(endDate.valueOf())){
        if(endDate < new Date()){
          element.style.display = "none";
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-l2"]) return;
  try {
    
   var loadProductRecommendationsIntoSection = function() {
     // Look for an element with class 'product-recommendations'
     var productRecommendationsSection = document.querySelector("[data-product-recommendation]");
     if (productRecommendationsSection === null) {
        return;
      }
     // Read product id from data attribute
     var productId = productRecommendationsSection.dataset.productId;
     // Read base URL from data attribute
     var baseUrl = productRecommendationsSection.dataset.baseUrl;
     // Read limit from data attribute
     var limit = productRecommendationsSection.dataset.limit;
     // Build request URL
     var requestUrl = baseUrl + "?section_id=product-recommendations-l2&product_id=" + productId + "&limit=" + limit;
     // Create request and submit it using Ajax
     fetch(baseUrl + "?section_id=product-recommendations-l2&product_id=" + productId + "&limit=" + limit)
      .then((response) =>  response.text())
      .then((html) => {
        var parser = new DOMParser();
    	var doc = parser.parseFromString(html, 'text/html');
        var container = document.createElement("div");
        container.innerHTML = html;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector("[data-product-recommendation]").innerHTML;
      });    
   };
  
  // Listen for changes done in the Theme Editor
   document.addEventListener("shopify:section:load", function(event) {
     console.log("Event detail is: ", event.detail)
     if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
     }
   });
   // Fetching the recommendations on page load
   loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
   var productRecommendationsSection = document.querySelector("[data-product-recommendation]");
     // Read product id from data attribute
     var productId = productRecommendationsSection.dataset.productId;
     // Read base URL from data attribute
     var baseUrl = productRecommendationsSection.dataset.baseUrl;
     // Read limit from data attribute
     var limit = productRecommendationsSection.dataset.limit;
     // Build request URL
     var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
     // Create request and submit it using Ajax

   var loadProductRecommendationsIntoSection = function() {
     // Look for an element with class 'product-recommendations'
     var productRecommendationsSection = document.querySelector("[data-product-recommendation]");
     if (productRecommendationsSection === null) {
        return;
      }
     // Read product id from data attribute
     var productId = productRecommendationsSection.dataset.productId;
     // Read base URL from data attribute
     var baseUrl = productRecommendationsSection.dataset.baseUrl;
     // Read limit from data attribute
     var limit = productRecommendationsSection.dataset.limit;
     // Build request URL
     var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
     // Create request and submit it using Ajax
     var request = new XMLHttpRequest();
     request.open("GET", requestUrl);
     request.onload = function() {
       if (request.status >= 200 && request.status < 300) {
         var container = document.createElement("div");
         container.innerHTML = request.response;
         productRecommendationsSection.parentElement.innerHTML = container.querySelector("[data-product-recommendation]").innerHTML;
		 document.querySelector('.recommendation_title').innerHTML=ajaxTitle;
         document.querySelector('.recommendation_title_parent').classList.add(ajaxTitleAlign);
       } else {
          console.log("**Error in  request! ", request.status);
        }
     };
     request.send();
   };

  // Listen for changes done in the Theme Editor
   document.addEventListener("shopify:section:load", function(event) {
     console.log("Event detail is: ", event.detail)
     if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
     }
   });
   // Fetching the recommendations on page load
   loadProductRecommendationsIntoSection();

 

  } catch(e) { console.error(e); }
})();
})();
